module.exports = __webpack_public_path__ + "static/img/qrCode.dc2cfada.png";